import { Ran } from './utils.js';

const GCSPI_MAX_MULTI_IO_CNT = 54;
const GCSPI_NUTRI_PUMP_CNT_MAX = 4;
const GCSPI_MAX_SLAVE_CNT = 2;
const GCSPI_MAX_SCHEDULE_CNT = 4;
const GCSPI_MAX_NUTRIENT_CNT = 1;
const GCSPI_MAX_IRRIGATION_CNT = 1;

let latest_slaves = [];

export function CreateSimulationInit(socket, display_name, type, username) {
  var req = { command: 'mock_initialize', cookie: document.cookie, data: {} };
  req.socket = socket;
  req.data['display_name'] = display_name;
  req.data['type'] = type;
  req.data['mac_address'] = Ran(0, 9) + '-' + Ran(0, 9) + '-' + Ran(0, 9) + '-' + Ran(9, 0);
  req.data['project_id'] = type === 5155 ? 0 : 0;
  req.data['version'] = '#latest';
  req['internal_id'] = display_name.toLowerCase().replace(' ', '_');
  return req;
}

export function SimuInfoGraph(ub, lb) {
  let graph = [lb];
  for (let i = 0; i < 180; i++) {
    const last_value = graph[graph.length - 1];
    const lower = 5 - (last_value - lb <= 5) ? last_value - lb : 0;
    const upper = 5 - (ub - last_value <= 5) ? ub - last_value : 0;
    graph.push(last_value + Ran(-lower, upper));
  }
  return graph;
}

// *** SendValues *** //
export function SimulationGetSendValueRequest(request_values_full, internal_id, zones = []) {
  // Initialize json request.
  const date = new Date();
  var json_request = {
    internal_id: internal_id,
    command: 'update_values',
    is_zoned: zones.length > 0
  };

  // Create random values
  var settings = { timestamp: date.getTime() };
  settings.cur_values = {};
  settings.cur_values['humidity'] = Ran(598, 602);
  settings.cur_values['temp'] = Ran(269, 271);
  settings.cur_values['vpd'] = Ran(69, 71);
  settings.cur_values['temp_leaf_current'] = Ran(238, 243);
  settings.cur_values['co2'] = Ran(1400, 1500);
  settings.cur_values['neg_pressure'] = 3999;
  settings.cur_values['temp_heating_mat'] = Ran(279, 281);
  settings.cur_values['humidity_max'] = Ran(602, 602);
  settings.cur_values['humidity_min'] = Ran(598, 598);
  settings.cur_values['temp_max'] = Ran(260, 260);
  settings.cur_values['temp_min'] = Ran(258, 258);
  settings.cur_values['info_interval_timer_active'] = Ran(0, 1);
  settings.cur_values['info_interval_timer'] = '00:00:0' + Ran(0, 1);
  settings.cur_values['info_interval_2_timer_active'] = Ran(0, 1);
  settings.cur_values['info_interval_2_timer'] = '00:0' + Ran(0, 1) + ':00';

  settings.cur_values['info_lights'] = 100;
  settings.cur_values['time'] = new Date().toLocaleTimeString('de-DE').split(' ')[0]; // "14:55:50";
  settings.cur_values['date'] = '05.03.2020'; // "28.09.2020";
  settings.cur_values['phase'] = Ran(1, 1);
  settings.cur_values['cur_day'] = 10;
  settings.cur_values['info_temp_sp'] = Ran(270, 270);
  settings.cur_values['info_humidity_sp'] = Ran(600, 600);
  settings.cur_values['temp_heater_setpoint_info'] = Ran(220, 220);
  settings.cur_values['rh_intake_current'] = Ran(420, 420);
  settings.cur_values['temp_intake_current'] = Ran(210, 210);

  // Version AC
  settings.cur_values['vol_water_content'] = Ran(520, 530);
  settings.cur_values['ec_root_zone'] = Ran(2400, 2500);
  settings.cur_values['temp_root_zone'] = Ran(243, 244);
  settings.cur_values['ec_nutrient_solution'] = Ran(1400, 1500);
  settings.cur_values['ph_nutrient_solution'] = Ran(7100, 7200);
  settings.cur_values['temp_nutrient_solution'] = Ran(243, 244);
  settings.cur_values['irrigation_state'] = 0;
  settings.cur_values['irrigation_phase_info'] = 2;
  settings.cur_values['irrigation_err'] = 0;
  settings.cur_values['hvac_status'] = 0;
  settings.cur_values['hvac_rh_info'] = 544;
  settings.cur_values['hvac_temp_info'] = 225;
  settings.cur_values['hvac_compress_status'] = 0;
  settings.cur_values['hvac_alarm_status'] = 0;
  settings.cur_values['hvac_info'] = 0;
  settings.cur_values['show_hvac_info'] = 1;
  settings.cur_values['hvac_status_2'] = 0;
  settings.cur_values['hvac_rh_info_2'] = 444;
  settings.cur_values['hvac_temp_info_2'] = 125;
  settings.cur_values['hvac_compress_status_2'] = 0;
  settings.cur_values['hvac_alarm_status_2'] = 0;
  settings.cur_values['hvac_info_2'] = 0;
  settings.cur_values['show_hvac_info_2'] = 1;
  settings.cur_values['hvac_status_3'] = 0;
  settings.cur_values['hvac_rh_info_3'] = 644;
  settings.cur_values['hvac_temp_info_3'] = 325;
  settings.cur_values['hvac_compress_status_3'] = 0;
  settings.cur_values['hvac_alarm_status_3'] = 0;
  settings.cur_values['hvac_info_3'] = 0;
  settings.cur_values['show_hvac_info_3'] = 1;
  settings.cur_values['hvac_unit_type'] = 1;
  settings.cur_values['hvac_unit_type_2'] = 2;
  settings.cur_values['hvac_unit_type_3'] = 2;
  settings.cur_values['hvac_init_status'] = 0;
  settings.cur_values['hvac_rh_setpoint_trans'] = 600;
  settings.cur_values['hvac_temp_setpoint_trans'] = 270;
  settings.cur_values['hvac_op_mode_info'] = 0;
  settings.cur_values['hvac_init_status_2'] = 0;
  settings.cur_values['hvac_rh_setpoint_trans_2'] = 500;
  settings.cur_values['hvac_temp_setpoint_trans_2'] = 170;
  settings.cur_values['hvac_op_mode_info_2'] = 1;
  settings.cur_values['hvac_init_status_3'] = 0;
  settings.cur_values['hvac_rh_setpoint_trans_3'] = 700;
  settings.cur_values['hvac_temp_setpoint_trans_3'] = 370;
  settings.cur_values['hvac_op_mode_info_3'] = 4;
  settings.cur_values['slave_info_count'] = GCSPI_MAX_SLAVE_CNT;
  settings.cur_values['slave_infos'] = [];

  for (let i = 0; i < GCSPI_MAX_SLAVE_CNT; i++) {
    let slave = {};
    slave['slave_address'] = i === 0 ? 10 : 11;
    slave['slave_status'] = i === 0 ? 1 : 1;
    slave['slave_elapsed_time'] = i === 0 ? 0 : 60;
    settings.cur_values.slave_infos.push(slave);
  }
  settings.cur_values['redox_current'] = Ran(621, 622);
  settings.cur_values['dos_current'] = Ran(972, 971);

  settings.ec_fans = {};
  settings.ec_fans['ec_fans_intake_out'] = Ran(30, 31);
  settings.ec_fans['ec_fans_intake_rpm'] = Ran(1202, 1205);
  settings.ec_fans['ec_fans_exhaust_out'] = Ran(40, 41);
  settings.ec_fans['ec_fans_exhaust_rpm'] = Ran(1448, 1450);

  settings.multi_out_values = {};
  settings.multi_out_values['out_count'] = 12;
  settings.multi_out_values['out_' + 1 + '_state'] = Ran(30, 31);
  settings.multi_out_values['out_' + 2 + '_state'] = Ran(40, 41);
  settings.multi_out_values['out_' + 3 + '_state'] = 0;
  settings.multi_out_values['out_' + 4 + '_state'] = 1;
  settings.multi_out_values['out_' + 5 + '_state'] = 1;
  for (var i = 6; i <= 25; i++) {
    // TODO: Select different ranges, depending in function.
    settings.multi_out_values['out_' + i + '_state'] = Ran(50, 65); // 0,1 => value %
  }

  // Version ACAB
  settings.multi_io_infos = [];
  for (let i = 0; i < GCSPI_MAX_MULTI_IO_CNT; i++) {
    let io = {};
    io['addr_gcl'] = i < 48 ? 10 : 11;
    io['status'] = Ran(30, 31);
    io['info'] = Ran(100, 200);
    io['info_type'] = 1;
    settings.multi_io_infos.push(io);
  }

  if (request_values_full || zones.length > 0) {
    settings.system = {};
    settings.system['temp_format'] = 0; //Ran(0,1);
    settings.system['vpd_format'] = 0; //Ran(0,1);
    settings.system['date_format'] = 1; //Ran(0,1);
    settings.system['language'] = 1; //Ran(0,1);
    settings.system['display_timeout'] = 3; //Ran(0,3);
    settings.system['fan_type_select'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_rh'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_temp'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_co2'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_pressure'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_heating_mat'] = 0; //Ran(0,2);
    settings.system['multi_sensor_handling_leaf'] = 0; //Ran(0,2);
    settings.system['filter_val_sensor_co2'] = 0; //Ran(0,7);
    settings.system['action_transmit_filter_sensor'] = 0; //Ran(0,1);
    settings.system['calib_val_sensor_co2'] = 400; //Ran(0,2000);
    settings.system['action_transmit_calib_filter_sensor_co2'] = 0; //Ran(0,1);
    settings.system['fw_version_number'] = '5055pre0.00.00b';
    settings.system['esp32_firmware_name'] = '5055pre0.00.00b';
    settings.system['pressure_auto_cal'] = Ran(0, 0);
  }

  if (request_values_full === true) {
    settings.climate = {};
    settings.climate['humidity_sp_day'] = Ran(10, 95);
    settings.climate['humidity_sp_night'] = Ran(10, 95);
    settings.climate['temp_sp_day'] = Ran(270, 270);
    settings.climate['temp_sp_night'] = Ran(200, 200);
    settings.climate['vpd_sp'] = Ran(70, 70);
    settings.climate['vpd_sp_night'] = Ran(100, 100);
    settings.climate['vpd_calc_enable'] = Ran(0, 2);
    settings.climate['temp_sp_heater_day'] = Ran(200, 200);
    settings.climate['temp_sp_heater_night'] = Ran(160, 160);
    settings.climate['toggle_temp_heating_mat_day'] = Ran(1, 1);
    settings.climate['temp_sp_heating_mat_day_abs'] = Ran(300, 300);
    settings.climate['temp_sp_heating_mat_day_rel'] = Ran(30, 30);
    settings.climate['toggle_temp_heating_mat_night'] = Ran(1, 1);
    settings.climate['temp_sp_heating_mat_night_abs'] = Ran(230, 230);
    settings.climate['temp_sp_heating_mat_night_rel'] = Ran(30, 30);

    settings.climate['dehumidification_mode'] = Ran(1, 1);
    settings.climate['heating_to_dehumidify_en'] = 0;
    settings.climate['preheat_night_day'] = Ran(0, 0);

    // CO2-Settings
    settings.co2 = {};
    settings.co2['co2_control'] = Ran(0, 0);
    settings.co2['co2_sp'] = Ran(1200, 1200);
    settings.co2['room_vol_sp'] = Ran(100, 100);
    settings.co2['co2_flow'] = Ran(80, 80);
    settings.co2['exhaust_fans_flow'] = Ran(1450, 1450);
    settings.co2['temp_sp_co2'] = Ran(320, 320);
    // Fans EC co2
    settings.co2['exhaust_fan_ec_max_co2'] = Ran(70, 100);
    settings.co2['exhaust_fan_ec_min_co2'] = Ran(10, 30);
    settings.co2['intake_fan_ec_max_co2'] = Ran(70, 100);
    settings.co2['intake_fan_ec_min_co2'] = Ran(10, 30);
    // Fans AC co2
    settings.co2['exhaust_fan_ac_max_co2'] = Ran(70, 100);
    settings.co2['exhaust_fan_ac_min_co2'] = Ran(10, 30);
    settings.co2['intake_fan_ac_max_co2'] = Ran(70, 100);
    settings.co2['intake_fan_ac_min_co2'] = Ran(10, 30);
    settings.co2['room_scale'] = Ran(0, 2);
    settings.co2['temp_heater_co2'] = Ran(60, settings.co2['temp_sp_co2'] - 10);
    settings.co2['co2_cylinder_current_valve'] = 1;
    settings.co2['co2_cylinder_1_status'] = 1;
    settings.co2['co2_cylinder_2_status'] = 0;
    settings.co2['co2_cylinder_1_remaining'] = 80;
    settings.co2['co2_cylinder_2_remaining'] = 0;

    // Ventilation
    settings.ventilation = {};
    settings.ventilation['pressure_percent_day'] = 137; // Ran(100,100);
    settings.ventilation['pressure_percent_night'] = 137; // Ran(100, 100);
    // Fans EC day/night
    settings.ventilation['exhaust_fan_ec_min_day'] = Ran(10, 30);
    settings.ventilation['exhaust_fan_ec_max_day'] = Ran(70, 100);
    settings.ventilation['exhaust_fan_ec_min_night'] = Ran(10, 30);
    settings.ventilation['exhaust_fan_ec_max_night'] = Ran(70, 100);
    settings.ventilation['intake_fan_ec_max_day'] = Ran(70, 100);
    settings.ventilation['intake_fan_ec_max_night'] = Ran(70, 100);
    settings.ventilation['intake_fan_ec_min_day'] = Ran(10, 30);
    settings.ventilation['intake_fan_ec_min_night'] = Ran(10, 30);
    // Fans AC day/night
    settings.ventilation['exhaust_fan_ac_min_day'] = Ran(10, 30);
    settings.ventilation['exhaust_fan_ac_max_day'] = Ran(70, 100);
    settings.ventilation['exhaust_fan_ac_min_night'] = Ran(10, 30);
    settings.ventilation['exhaust_fan_ac_max_night'] = Ran(70, 100);
    settings.ventilation['intake_fan_ac_max_day'] = Ran(70, 100);
    settings.ventilation['intake_fan_ac_max_night'] = Ran(70, 100);
    settings.ventilation['intake_fan_ac_min_day'] = Ran(10, 30);
    settings.ventilation['intake_fan_ac_min_night'] = Ran(10, 30);

    settings.ventilation['deviation_rpm_reduction'] = Ran(2, 2);
    settings.ventilation['pressure_pa'] = Ran(5, 5);
    settings.ventilation['pressure_auto_cal'] = Ran(0, 0);

    settings.timing = {};
    settings.timing['time_cont_hour'] = Ran(0, 23);
    settings.timing['time_cont_min'] = Ran(0, 59);
    settings.timing['time_cont_sec'] = Ran(0, 59);
    settings.timing['time_cont_day'] = Ran(1, 31);
    settings.timing['time_cont_month'] = Ran(1, 12);
    settings.timing['time_cont_year'] = Ran(2020, 2021);
    settings.timing['start_day_hour'] = Ran(6, 6);
    settings.timing['start_day_min'] = Ran(0, 0);
    settings.timing['end_day_hour'] = Ran(18, 18);
    settings.timing['end_day_min'] = Ran(0, 0);
    settings.timing['interval_on_day_hour'] = 0; //Ran(0,23);
    settings.timing['interval_on_day_min'] = 2; //Ran(0,59);
    settings.timing['interval_on_day_sec'] = 0; //Ran(0,59);
    settings.timing['interval_off_day_hour'] = 0; //Ran(0,23);
    settings.timing['interval_off_day_min'] = 15; //Ran(0,59);
    settings.timing['interval_off_day_sec'] = 0; //Ran(0,59);
    settings.timing['interval_on_night_hour'] = 0; //Ran(0,23);
    settings.timing['interval_on_night_min'] = 1; //Ran(0,59);
    settings.timing['interval_on_night_sec'] = 0; //Ran(0,59);
    settings.timing['interval_off_night_hour'] = 0; //Ran(0,23);
    settings.timing['interval_off_night_min'] = 30; //Ran(0,59);
    settings.timing['interval_off_night_sec'] = 0; //Ran(0,59);
    settings.timing['event1_start_hour'] = 14; //Ran(0,23);
    settings.timing['event1_start_min'] = 6; //Ran(0,59);
    settings.timing['event1_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event1_duration_min'] = 0; //Ran(0,59);
    settings.timing['event1_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event2_start_hour'] = 0; //14;//Ran(0,23);
    settings.timing['event2_start_min'] = 6; //Ran(0,59);
    settings.timing['event2_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event2_duration_min'] = 0; //Ran(0,59);
    settings.timing['event2_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event3_start_hour'] = 14; //Ran(0,23);
    settings.timing['event3_start_min'] = 6; //Ran(0,59);
    settings.timing['event3_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event3_duration_min'] = 0; //Ran(0,59);
    settings.timing['event3_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event4_start_hour'] = 14; //Ran(0,23);
    settings.timing['event4_start_min'] = 6; //Ran(0,59);
    settings.timing['event4_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event4_duration_min'] = 0; //Ran(0,59);
    settings.timing['event4_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event5_start_hour'] = 14; //Ran(0,23);
    settings.timing['event5_start_min'] = 6; //Ran(0,59);
    settings.timing['event5_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event5_duration_min'] = 0; //Ran(0,59);
    settings.timing['event5_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event6_start_hour'] = 14; //Ran(0,23);
    settings.timing['event6_start_min'] = 6; //Ran(0,59);
    settings.timing['event6_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event6_duration_min'] = 0; //Ran(0,59);
    settings.timing['event6_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event7_start_hour'] = 14; //Ran(0,23);
    settings.timing['event7_start_min'] = 6; //Ran(0,59);
    settings.timing['event7_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event7_duration_min'] = 0; //Ran(0,59);
    settings.timing['event7_duration_sec'] = 0; //Ran(0,59);
    settings.timing['event8_start_hour'] = 14; //Ran(0,23);
    settings.timing['event8_start_min'] = 6; //Ran(0,59);
    settings.timing['event8_duration_hour'] = 0; //Ran(0,23);
    settings.timing['event8_duration_min'] = 0; //Ran(0,59);
    settings.timing['event8_duration_sec'] = 0; //Ran(0,59);

    settings.timing['time_event1_exec_gap'] = 0;
    settings.timing['time_event2_exec_gap'] = 0;
    settings.timing['time_event3_exec_gap'] = 0;
    settings.timing['time_event4_exec_gap'] = 0;
    settings.timing['time_event5_exec_gap'] = 0;
    settings.timing['time_event6_exec_gap'] = 0;
    settings.timing['time_event7_exec_gap'] = 0;
    settings.timing['time_event8_exec_gap'] = 0;

    settings.timing['time_interval_2_on_day_hour'] = 0;
    settings.timing['time_interval_2_on_day_minute'] = 2;
    settings.timing['time_interval_2_on_day_sec'] = 0;
    settings.timing['time_interval_2_off_day_hour'] = 0;
    settings.timing['time_interval_2_off_day_minute'] = 15;
    settings.timing['time_interval_2_off_day_sec'] = 0;
    settings.timing['time_interval_2_on_night_hour'] = 0;
    settings.timing['time_interval_2_on_night_minute'] = 1;
    settings.timing['time_interval_2_on_night_sec'] = 0;
    settings.timing['time_interval_2_off_night_hour'] = 0;
    settings.timing['time_interval_2_off_night_minute'] = 30;
    settings.timing['time_interval_2_off_night_sec'] = 0;

    settings.lights = {};
    settings.lights['lights_max'] = 100; //Ran(10,115);
    settings.lights['lights_min'] = 10; //Ran(9,100);
    settings.lights['light_sunrise_duration'] = 5; //Ran(0,90);
    settings.lights['lights_dim_over_temp_enable'] = 0;
    settings.lights['lights_dim_over_temp_temp_day'] = 300;
    settings.lights['lights_dim_over_temp_temp_co2'] = 350;
    settings.lights['lights_dim_over_temp_reduct_ph1'] = 70;
    settings.lights['lights_dim_over_temp_reduct_ph2'] = 30;
    settings.lights['lights_dim_over_temp_reduct_ph3'] = 9;
    settings.lights['lights_dim_over_temp_reduct_wait_minute'] = 3;

    settings.advanced = {};
    settings.advanced['fan_ac_intake_turnoff'] = 25; //Ran(12,20);
    settings.advanced['fan_ac_exhaust_turnoff'] = 25; //an(12,20);

    settings.advanced['leaf_temp_diff'] = 30; //Ran(0,70);
    settings.advanced['hysteresis_co2'] = 15; //Ran(1,2000);
    settings.advanced['reg_kd_pressure'] = 8; //Ran(1,50);
    settings.advanced['reg_kd_temp_air'] = 15; //Ran(1,50);
    settings.advanced['interval_ramp_temp_sp'] = 15; //Ran(2,600);
    settings.advanced['reg_type_humidifier'] = 1; //Ran(0,1);
    settings.advanced['hysteresis_humidifier'] = 15; //Ran(2,300);
    settings.advanced['humidifier_kd'] = 160; //Ran(100,400);
    settings.advanced['reg_type_dehumidifier'] = 0; //Ran(0,1);
    settings.advanced['hysteresis_dehumidifier'] = 40; //Ran(2,300);
    settings.advanced['offset_sp_dehumidifier'] = -40; //Ran(2,30);
    settings.advanced['hysteresis_heater'] = 20; //Ran(1,300);
    settings.advanced['hysteresis_chiller_low'] = 10; //Ran(1,300);
    settings.advanced['hysteresis_chiller_high'] = 20; //Ran(1,300);
    settings.advanced['co2_min_dose_ms'] = 100; //Ran(1,300);
    settings.advanced['intake_sens_min_diff_rh'] = 30;
    settings.advanced['intake_sens_min_diff_temp'] = 3; //Ran(1,300);
    settings.advanced['intake_sens_retry_wait'] = 30; //Ran(1,300);
    settings.advanced['intake_sens_retry_duration'] = 20; //Ran(1,300);
    settings.advanced['rh_min_with_vpd'] = 10; //Ran(1,300);
    settings.advanced['rh_max_with_vpd'] = 80; //Ran(1,300);
    settings.advanced['lights_dim_over_temp_hyst'] = 30;
    settings.advanced['lights_dim_over_temp_delay_sec'] = 30;
    settings.advanced['offset_sp_humidifier'] = 40;
    settings.advanced['dehumid_exhaust_threshold'] = 5;
    settings.advanced['dehumid_exhaust_temp_untercut_max_allowed'] = 5;
    settings.advanced['offset_sp_humidifier_night'] = -80; //Ran(2,30);
    settings.advanced['offset_sp_dehumidifier_night'] = 80; //Ran(2,30);
    settings.advanced['offset_sp_heater_day'] = -1;
    settings.advanced['offset_sp_heater_night'] = -1;
    settings.advanced['offset_sp_heater_co2'] = -1;
    settings.advanced['offset_sp_chiller_day'] = -1;
    settings.advanced['offset_sp_chiller_night'] = -1;

    settings.multi_out = {};
    /* 
    //if GrowBase
    settings.multi_out["out_" + 1 + "_type"] = 3;
    settings.multi_out["out_" + 1 + "_func"] = 1;
    settings.multi_out["out_" + 2 + "_type"] = 3;
    settings.multi_out["out_" + 2 + "_func"] = 0;
    settings.multi_out["out_" + 3 + "_type"] = 3;
    settings.multi_out["out_" + 3 + "_func"] = 2;
    settings.multi_out["out_" + 4 + "_type"] = 1;
    settings.multi_out["out_" + 4 + "_func"] = 4;
    settings.multi_out["out_" + 5 + "_type"] = 1;
    settings.multi_out["out_" + 5 + "_func"] = 4;
    */
    //if GrowBase Pro
    settings.multi_out['out_' + 1 + '_type'] = 0;
    settings.multi_out['out_' + 1 + '_func'] = 1;
    settings.multi_out['out_' + 2 + '_type'] = 0;
    settings.multi_out['out_' + 2 + '_func'] = 0;
    settings.multi_out['out_' + 3 + '_type'] = 0;
    settings.multi_out['out_' + 3 + '_func'] = 2;
    settings.multi_out['out_' + 4 + '_type'] = 0;
    settings.multi_out['out_' + 4 + '_func'] = 4;
    settings.multi_out['out_' + 5 + '_type'] = 2;
    settings.multi_out['out_' + 5 + '_func'] = 4;
    settings.multi_out['memo_names'] = [{ id: 'out_1_memo', name: 'test-memo' }];
    for (var j = 6; j <= 25; j++) {
      settings.multi_out['out_' + j + '_type'] = 1; //Ran(0,3);
      settings.multi_out['out_' + j + '_func'] = 4;
    }

    settings.multi_io = {};
    settings.multi_io.ios = [];
    settings.multi_io.memo_names = [
      { id: 'out_1_memo', name: 'test-memo' },
      { id: 'out_10_memo', name: 'test-memo 10' }
    ];
    for (let i = 0; i < GCSPI_MAX_MULTI_IO_CNT; i++) {
      let io = {};
      io['addr_gcl'] = i < 48 ? 10 : 11; // Backward compatibility
      io['id_per_addr'] = i < 48 ? i : i - 48;
      io['function'] = i < 48 ? 4 : 2;
      io['hw_type'] = i < 48 ? 20 : 22;
      io['zone'] = 0;
      settings.multi_io.ios.push(io);
    }

    settings.alarms = {};
    settings.alarms['alarm_low_temperature_air_day_setting'] = 100;
    //  = Ran(50,settings.climate.temp_sp_day-20);
    settings.alarms['alarm_over_temperature_air_day_setting'] = 400;
    //  = Ran(settings.climate.temp_sp_day+20,700);
    settings.alarms['alarm_low_temperature_air_night_setting'] = 100;
    //  = Ran(50,settings.climate.temp_sp_night-20);
    settings.alarms['alarm_over_temperature_air_night_setting'] = 400;
    //  = Ran(settings.climate.temp_sp_day+20,500);
    settings.alarms['alarm_low_temperature_air_co2_setting'] = 100;
    //  = Ran(50,settings.co2.temp_sp_co2-20);
    settings.alarms['alarm_over_temperature_air_co2_setting'] = 500;
    //  = Ran(settings.co2.temp_sp_co2+20,500);
    settings.alarms['alarm_low_co2_concentration_setting'] = 400;
    //  = Ran(300,settings.co2.co2_sp-100);
    settings.alarms['alarm_over_co2_concentration_setting'] = 1900;
    //  = Ran(settings.co2.co2_sp+100,1800);
    settings.alarms['alarm_low_rh_day_setting'] = 20;
    //  = Ran(10,settings.climate.humidity_sp_day-5);
    settings.alarms['alarm_over_rh_day_setting'] = 95;
    //  = Ran(settings.climate.humidity_sp_day+5,90);
    settings.alarms['alarm_low_rh_night_setting'] = 20;
    //  = Ran(5,settings.climate.humidity_sp_night-5);
    settings.alarms['alarm_over_rh_night_setting'] = 95;
    //  = Ran(settings.climate.humidity_sp_night+5,95);
    settings.alarms['alarm_low_vpd_setting'] = 20;
    //  = Ran(20,settings.climate.vpd_sp-20);
    settings.alarms['alarm_over_vpd_setting'] = 200;
    //  = Ran(settings.climate.vpd_sp+20,140);
    settings.alarms['alarm_low_vpd_night_setting'] = 20;
    //  = Ran(20,settings.climate.vpd_sp_night-20);
    settings.alarms['alarm_over_vpd_night_setting'] = 200;
    //  = Ran(settings.climate.vpd_sp_night+20,140);
    settings.alarms['alarm_low_temperature_air_day_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_temperature_air_day_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_temperature_air_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_temperature_air_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_temperature_air_co2_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_temperature_air_co2_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_co2_concentration_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_co2_concentration_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_rh_day_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_rh_day_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_rh_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_rh_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_vpd_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_vpd_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_low_vpd_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_over_vpd_night_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_rht_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_co2_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_pressure_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_heating_mat_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_leaf_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_error_power_extender_enable'] = 0; //Ran(0,1);
    settings.alarms['alarm_sensor_error_intake_enable'] = 0; //Ran(0,1);
    settings.alarms['expected_power_extender_out_cnt'] = 0; //Ran(1,20);

    settings['nutrition'] = {};
    settings.nutrition['ec_setpoint'] = 220;
    settings.nutrition['ph_setpoint'] = 420;
    settings.nutrition['temp_setpoint'] = 210;
    settings.nutrition['pump_cnt_used'] = GCSPI_NUTRI_PUMP_CNT_MAX;
    settings.nutrition['pumps'] = [];
    const pump_memo_names = ['Comp A', 'Comp B', 'Additive 1', 'Additive 2'];
    for (let i = 0; i < GCSPI_NUTRI_PUMP_CNT_MAX; i++) {
      settings.nutrition.pumps.push({
        type: i < 2 ? 0 : 2,
        unit: i < 2 ? 1 : 0,
        value: i < 2 ? 25 : 20,
        name: pump_memo_names[i]
      });
    }

    settings['irrigation'] = {};
    settings.irrigation['irrigation_p0_dry_back_abs'] = 35;
    settings.irrigation['irrigation_p0_phase_timeout_minutes'] = 90;
    settings.irrigation['irrigation_p0_enable'] = 1;
    settings.irrigation['irrigation_p0_enable_timeout'] = 1;
    settings.irrigation['irrigation_p1_shot_size_vwc_rel'] = 20;
    settings.irrigation['irrigation_p1_target_vwc_abs'] = 64;
    settings.irrigation['irrigation_p1_dry_back_rel'] = 0;
    settings.irrigation['irrigation_p1_wait_after_shot_minutes'] = 2;
    settings.irrigation['irrigation_p1_phase_timeout_minute'] = 90;
    settings.irrigation['irrigation_p1_shot_duration_timeout_minutes'] = 5;
    settings.irrigation['irrigation_P1_vwc_auto_sp_max_duration_no_increase_seconds'] = 30;
    settings.irrigation['irrigation_p1_memo_max_vwc'] = 1;
    settings.irrigation['vwc_auto_sp_max_allowed_lower'] = 60;
    settings.irrigation['vwc_auto_sp_max_allowed_upper'] = 80;
    settings.irrigation['irrigation_p2_strategy'] = 0;
    settings.irrigation['vwc_auto_sp_max_saved_info'] = 679;
    settings.irrigation['irrigation_p2_offset_target_vwc'] = 20;
    settings.irrigation['irrigation_p2_target_vwc_abs'] = 65;
    settings.irrigation['irrigation_p2_dry_back_abs'] = 30;
    settings.irrigation['irrigation_p2_shot_duration_timeout_minutes'] = 5;
    settings.irrigation['irrigation_p2_wait_after_shot_s'] = 5;
    settings.irrigation['irrigation_p2_end_before_sunset'] = '08:30:00';
    settings.irrigation['irrigation_p3_min_vwc_abs'] = 20;
    settings.irrigation['irrigation_p3_shot_size_rel'] = 3;
    settings.irrigation['irrigation_p3_min_wait_after_shot'] = 120;
    settings.irrigation['enable_irrigation'] = true;
  }

  if (zones.length > 0) {
    // Update slaves based on multi_ios
    UpdateSlaves(settings.multi_io_infos, settings.multi_io);
    // If slaves exist, remove multi_io and multi_io_infos fields since they are
    // then handled by slace-structure
    if (latest_slaves && latest_slaves.length > 0) {
      delete settings['multi_io'];
      delete settings['multi_io_infos'];
    }

    // Constuct json request
    json_request.data = {};
    json_request.data['timestamp'] = settings.timestamp;
    json_request.data['slaves'] = latest_slaves;
    json_request.data['system'] = settings.system;
    json_request.data['zones'] = JSON.parse(JSON.stringify(zones));
    for (var i = 0; i < zones.length; i++) {
      json_request.data.zones[i]['settings'] = settings;
    }
    console.log('[simu] Sending values: ', json_request.data);
  } else {
    json_request.data = settings;
  }
  return json_request;
}

function UpdateSlaves(multi_io_infos, multi_io) {
  console.log('[slaves] Updating slaves:', multi_io, multi_io_infos);
  // If multi_io(-infos) are not valid for updating slaves, return latest_slaves
  if (
    multi_io === undefined ||
    multi_io.ios === undefined ||
    multi_io_infos === undefined ||
    multi_io_infos.length !== multi_io.ios.length
  ) {
    return;
  }
  // Otherwise, rebuild slaves based on multi-io data.
  latest_slaves = [];
  // Convert multi-io to slaves:
  var per_slave = new Object();
  for (var i = 0; i < multi_io.ios.length; i++) {
    const io = multi_io.ios[i];
    const slave_entry = {
      id: io.id_per_addr,
      func: io['function'],
      type_id: io.hw_type,
      zone: io.zone.toString(),
      slave: multi_io_infos[i].addr_gcl,
      state: multi_io_infos[i]['status'],
      info: multi_io_infos[i].info,
      type: multi_io_infos[i].info_type,
      memo: '', // use memos in `settings.multi_io.memos`
      _index: i // used to reconstruct original index position
    };
    if (slave_entry.slave in per_slave) {
      per_slave[slave_entry.slave].push(slave_entry);
    } else {
      per_slave[slave_entry.slave] = [slave_entry];
    }
  }
  console.log('[slaves] got per_slave:', JSON.parse(JSON.stringify(per_slave)));
  // Add slaves
  let counter = 0;
  for (const [key, slave_entries] of Object.entries(per_slave)) {
    latest_slaves.push({
      address: parseInt(key),
      connected: 1,
      zone: 0,
      capabilities: [10],
      dev_variant: 144,
      baud: 1312,
      unique_id: counter++,
      abilities: ['in', 'out'],
      multi_outs: slave_entries
    });
  }
}

export function GenerateSimulationHistory(length, res, block, max) {
  res *= 1000; // convert to milli_seconds.
  var data = {
    time: [],
    humidity: [],
    temp: [],
    co2: [],
    vpd: [],
    temp_leaf_current: [],
    vol_water_content: [],
    ec_root_zone: []
  };

  // init start time
  const now = new Date();
  let milli_seconds = now.getTime();
  milli_seconds -= length * res * (max - block);

  const bounds = {
    humidity: [500, 700],
    temp: [200, 300],
    co2: [1300, 1600],
    vpd: [0, 100],
    temp_leaf_current: [200, 300],
    vol_water_content: [500, 600],
    ec_root_zone: [2300, 2600]
  };
  let last_vals = {
    humidity: Ran(bounds['humidity'][0], bounds['humidity'][1]),
    temp: Ran(bounds['temp'][0], bounds['temp'][1]),
    co2: Ran(bounds['co2'][0], bounds['co2'][1]),
    vpd: Ran(bounds['vpd'][0], bounds['vpd'][1]),
    temp_leaf_current: Ran(bounds['temp_leaf_current'][0], bounds['temp_leaf_current'][1]),
    vol_water_content: Ran(bounds['vol_water_content'][0], bounds['vol_water_content'][1]),
    ec_root_zone: Ran(bounds['ec_root_zone'][0], bounds['ec_root_zone'][1])
  };

  // Add values matching `length`:
  for (var i = 0; i < length; i++) {
    for (const [key, value] of Object.entries(last_vals)) {
      const lower = 5 - (value - bounds[key][0] <= 5) ? value - bounds[key][0] : 0;
      const upper = 5 - (bounds[key][1] - value <= 5) ? bounds[key][1] - value : 0;
      last_vals[key] = value + Ran(-lower, upper); // artificial deviation of +/- 5
      data[key].push(last_vals[key]);
    }
    data['time'].push(milli_seconds);
    milli_seconds += res;
  }
  return data;
}

export function CreateSimulationHistoryBlock(history, zones, data) {
  if (zones.length > 0) {
    history['id'] = data && 'id' in data ? data.id : '0';
    history['has_zone_data'] = 1;
    return history;
  } else {
    return history;
  }
}
